<!-- src/components/HomeContent.vue -->
<template>
  <div class="home-content">
    <!-- 轮播图 -->
    <div class="carousel" v-if="slides.length">
      <div
        class="slide"
        v-for="(img, idx) in slides"
        :key="idx"
        :class="{ active: idx === currentSlide }"
      >
        <img :src="img" alt="轮播图" />
      </div>
    </div>

    <!-- 视频分组 -->
    <div
      class="video-group"
      v-for="(group, gidx) in groups"
      :key="gidx"
    >
      <h3>{{ group.title }}</h3>
      <div class="grid">
        <div
          class="video-card"
          v-for="item in group.items"
          :key="item.id"
          @click="playVideo(item.id)"
        >
          <img :src="item.img" alt="封面" />
          <div class="name">{{ item.name }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeContent',
  data() {
    return {
      slides: [],       // 轮播图片列表
      currentSlide: 0,  // 当前激活的轮播索引
      groups: [],       // 推荐分组：[{ title, items: [...] }, ...]
      _timer: null      // 轮播定时器句柄
    };
  },

  
  methods: {
    // 拉取推荐数据
    async fetchRecommend() {
      try {
        // const json = await this.$fetchData('http://110.40.74.118:3345/api.php/api/video/homeRecommend');


        const res = await fetch('http://110.40.74.118:3345/api.php/video/homeRecommend');
        const json = await res.json();

        if (json.code === 200 && json.data) {
          const data = json.data;
          // 解析 banner 用作轮播
          this.slides = (data.banner || []).map(item => item.vod_pic);
          // 解析 group 为视频分组
          this.groups = (data.group || []).map(group => ({
            title: group.name,
            items: (group.array || []).map(item => ({
              id: item.vod_id,
              img: item.vod_pic,
              name: item.vod_name,
              desc: item.vod_content
            }))
          }));
          // 启动轮播
          if (this.slides.length && !this._timer) {
            this._timer = setInterval(() => {
              this.currentSlide = (this.currentSlide + 1) % this.slides.length;
            }, 3000);
          }
        } else {
          console.error('获取推荐数据失败:', json.msg);
        }
      } catch (err) {
        console.error('fetchRecommend 错误:', err);
      }
    },

    // 播放视频：与原生交互
    playVideo(videoId) {
      const msg = { action: 'playVideo', videoId };
      if (window.webkit?.messageHandlers?.nativeHandler) {
        window.webkit.messageHandlers.nativeHandler.postMessage(msg);
      } else if (window.Native?.postMessage) {
        window.Native.postMessage(JSON.stringify(msg));
      } else {
        console.log('播放模拟:', msg);
      }
    }
  },
  mounted() {
    this.fetchRecommend();
  },
  beforeUnmount() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }
};
</script>

<style scoped>
.home-content {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 轮播图 */
.carousel {
  position: relative;
  width: 100%;
  padding-top: 50%; /* 2:1 宽高比 */
  overflow: hidden;
  margin-bottom: 24px;
}
.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s;
}
.slide.active {
  opacity: 1;
}
.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

/* 视频分组 */
.video-group {
  margin-top: 24px;
}
.video-group h3 {
  margin-bottom: 12px;
  font-size: 1rem;
  color: #333;
}

/* 栅格布局 */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
}
.video-card {
  cursor: pointer;
}
.video-card img {
  width: 100%;
  aspect-ratio: 3 / 4; /* 竖图 3:4 */
  object-fit: cover;
  border-radius: 4px;
}
.name {
  margin-top: 4px;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.desc {
  font-size: 0.75rem;
  color: #888;
  height: 1.2rem; /* 大约两行文字高度 */
  overflow: hidden;
}
</style>